// extracted by mini-css-extract-plugin
module.exports = {"news":"News_news__v5KPC","news-tag":"News_news-tag__ERAXb","news-tag-label":"News_news-tag-label__csOZv"};